<capra-icon
  class="icon"
  [icon]="isAnalystStudio ? 'illo-ghost-ui-warning' : 'illo-create-sheet'"
  height="72px"
  width="72px"
></capra-icon>

<h2 class="heading text" [class.analyst-studio]="isAnalystStudio">
  {{ appName }} needs to connect to your Excel Account
</h2>
<p class="sub-heading text">
  Once you connect {{ appName }} to your Excel Account, Sheets you have access to will appear here.
</p>

<capra-button class="button" text="Set up account" (clicked)="redirect()"></capra-button>
